module.exports = __webpack_public_path__ + "static/media/ICONS_MARCAS.18338754.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_MARCAS.svg
// module id = 486
// module chunks = 0